import React, { Component } from 'react';
import moment from "moment";
import { Row, Button, message, DatePicker } from 'antd';
import { dataDefault, dataInputDefault } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Table1 from "./2-1";
import Table2 from "./2-2";
import Table3 from "./2-3";
import Table4 from "./2-4";

const { MonthPicker } = DatePicker;
function numConvert(num = 0) {
    num = Number(num || "0")
    return num
};
const totalIndexFooter = [0, 24, 26, 32, 44, 50, 54, 59];

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            update: false,
            dataTotal: [],
            dataFoot: [],
            dataInput: []
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        let dataTotal = [];
        totalIndexFooter.forEach((index, i) => {
            const file = data.reduce((a, b, j) => {
                if (j > index && j < (totalIndexFooter[i + 1] || data.length)) {
                    a += numConvert(b.name);
                }
                return a
            }, 0).toFixed(2)
            dataTotal[i] = {
                ...data[index],
                file,
                control: (numConvert(data[index].risks) == 0 ? 0 : file / numConvert(data[index].risks)).toFixed(4),
            }
        });
        dataTotal.push({
            name: "-",
            sort: dataTotal.length,
            risks: dataTotal.reduce((a, b) => { a += numConvert(b.risks); return a }, 0).toFixed(2),
            file: "",
            control: "",
        })
        let dataFoot = [{
            value: dataTotal.reduce((a, b) => { a += numConvert(b.file); return a }, 0).toFixed(2),
            name: "Total Points"
        }, {
            name: "Total Target Points",
            value: dataTotal[dataTotal.length - 1].risks
        }, {
            name: "%",
            value: (numConvert(dataTotal[dataTotal.length - 1].risks) == 0 ? 0 : dataTotal.reduce((a, b) => { a += numConvert(b.file); return a }, 0) / numConvert(dataTotal[dataTotal.length - 1].risks)).toFixed(2)
        }];

        this.setState({ data, dataTotal, dataFoot });
    }

    onChange = (name, data, flag) => {
        if (flag) {
            this.setState({ [data]: data });
            return
        }
        this.computeNum(data);
    }

    getDateData = async (date, isLastMonth) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);
        const dataBeginInput = JSON.stringify(dataInputDefault);
        let dataInput = JSON.parse(dataBeginInput);
        if (isLastMonth) {
            date = moment(date).subtract(1, 'month').format('YYYY-MM');
            if (this.state.data.some(x => x.id)) return message.error('当月数据已存在，无法填充！');
            this.setState({ data: [], dataInput: [], loading: true });
        }

        fetch(`/_controll_2_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.table && x.data.table.length > 0) {
                data = x.data.table.sort((a, b) => {
                    return numConvert(a.sort) - numConvert(b.sort)
                });
            }

            if (x.data.dataInput && x.data.dataInput.length > 0) {
                dataInput = x.data.dataInput;
            }
            if (isLastMonth) {
                data = data.map(x => { delete x.id; return x });
                dataInput = dataInput.map(x => { delete x.id; return x });
            }
            this.setState({
                loading: false,
                dataInput
            }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("MM");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataInput = this.state.dataInput.map(x => ({ ...x, year, month }));

        let dataFrom = new FormData();

        dataFrom.append('data', JSON.stringify({ data, dataInput }));
        console.log({ data, dataInput })
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/controllAdd_2_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data.every(x => x.id)) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {
        this.setState({ print: true, loading: true }, () => {
            imgSave('table2_1', 1.5, '9.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    render() {
        return (
            <div className="table">
                <Row className="title" id="table2_1"  >
                    <Row>
                        9.10 Finance Internal Control Checklist 财务内部控制清单
                        </Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                    loading: true,
                                    dataInput: [],
                                    dataFoot: [],
                                    dataTotal: []
                                });
                                this.getDateData(str)
                            }}
                        />
                        <Button
                            type="primary"
                            style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                            onClick={this.getDateData.bind(this, this.state.date, true)}
                        >填充上月数据</Button>
                    </Row>
                    <Table1 loading={this.state.loading} print={this.state.print} data={this.state.data} onChange={this.onChange} />
                    <Table2 loading={this.state.loading} print={this.state.print} data={this.state.dataTotal} />
                    <Table3 loading={this.state.loading} print={this.state.print} data={this.state.dataFoot} />
                    <Table4 loading={this.state.loading} print={this.state.print} data={this.state.dataInput} onChange={this.onChange} />
                </Row>
                <Auth auth="edit_9_10">
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.downloadSG}
                            loading={this.state.print}
                        >加入pdf</Button>

                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Row>
                </Auth>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-10/index.js